// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"758e8b03","856":"e9c91589"}[chunkId] + ".chunk.js";
};